





















import {Component, Prop, Vue, Emit, Model} from 'vue-property-decorator';

@Component({
  name: 'MyCheckbox',
})
export default class MyCheckbox extends Vue {
  @Prop() label: string;                                          // 文字展示
  @Prop({
    default: true
  }) val: string;                                                 // 选中的值
  @Prop({
    default: false
  }) disabled: boolean;                                           // 是否能使用
  @Prop({
    default: false
  }) isSwitch: boolean;

  @Model('change')
  propValue: boolean;                                             // 父组件传过来绑定的值

  /* 动态属性 */
  get isGroup(): boolean {                                                 // 是否在组里
    return this.$parent.$options['_componentTag'] === 'MyCheckboxGroup';
  }

  get isDisabled(): boolean {
    return this.$parent.disabled || this.disabled;
  }

  get isChecked() {
    const {isGroup, propValue} = this;
    if (!isGroup) {
      return propValue;
    } else {
      const {val, $parent: {propValueArr: selectItems}} = this;
      return selectItems.some(item => item === val);
    }
  }

  /*
    判断当前值是否在组内
     1. 是，返回最外层的数组
     2. 否，返回父组件传过来的值
  */
  get selfValue(): any {                                          // 当前组件的值
    return this.isGroup ? this.$parent.propValueArr : this.propValue;
  }

  /*
     判断当前值是否在组内
     1. 是，判断是否已经选中
        1) 是，则调用组的方法，将当前值从数组中删除
        2）否，则调用组的方法，将当前值添加到数组中
     2. 否，将新值返回给组
  */
  set selfValue(newValue) {
    const {isGroup, isChecked} = this;
    if (isGroup) {
      isChecked ? this.$parent.deleteItem(newValue) : this.$parent.selectItem(newValue);
    } else {
      this.emitChange(newValue);
    }
  }

  /*
     判断是否在组内
     1. 在组内的话，将绑定值设置为当前按钮的值，执行set方法，将新值传递给组。
     2. 单独使用，直接将绑定值取反即可。
   */
  handleClick() {
    const {isDisabled, isGroup, selfValue, val} = this;
    if (!isDisabled) {
      this.selfValue = isGroup ? val : !selfValue;
    }
  }

  // 只在 isGroup 为 false 起作用
  @Emit('change')
  emitChange(newValue: any): void {
    console.log(newValue);
  }
}
